import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Form, Grid } from 'semantic-ui-react';
import OverviewTable from '../../Filtering/OverviewTable/OverviewTable';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import FiltersPanel from '../../Filtering/FiltersPanel/FiltersPanel';
import ViewOptionsContainer from './ViewOptionsPanel/ViewOptionsContainer';
import { Formik, FormikActions, FormikValues } from 'formik';

type Props = {
  dataViewList: any;
  handleAddNewInventoryClick: () => void;
  isRenderExport: boolean;
  renderRowComparator: any;
};

const InventoryOverviewForm = ({
  dataViewList,
  handleAddNewInventoryClick,
  isRenderExport,
  renderRowComparator,
}: Props) => {
  const selectedRows = {};
  return (
    <Form id="chemicalProductOverviewForm" className="smallScreenReducePaddingOverview">
      <Grid stackable>
        <Grid.Row style={{ paddingTop: '5px' }}>
          <Grid.Column className="componentWithBottomMarginNoPadding">
            <AccordionWrapper
              accordionTitle={'filter.panel.title'}
              className="filterPanel"
              render={() => <FiltersPanel />}
            />
          </Grid.Column>
        </Grid.Row>
        {dataViewList.length > 0 ? (
          <Grid.Row className="componentWithBottomMarginNoPadding">
            <Grid.Column style={{ padding: '0px' }}>
              <Formik
                render={formikProps => (
                  <ViewOptionsContainer
                    formikProps={formikProps}
                    handleAddNewRecord={handleAddNewInventoryClick}
                    dataViewList={dataViewList}
                    isRenderExport={isRenderExport}
                    selectedRows={selectedRows}
                  />
                )}
                initialValues={undefined}
                onSubmit={() => {}}
              />
            </Grid.Column>
          </Grid.Row>
        ) : null}
        <Grid.Row className="componentWithBottomMarginNoPadding">
          <Grid.Column style={{ padding: '0px' }}>
            <OverviewTable
              id="inventoryTable"
              clearColumnsDefaultValues={['GEN_LOCATION_NAME', 'GEN_TRADE_NAME']}
              renderRowComparator={renderRowComparator}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

export default withTranslation()(InventoryOverviewForm);
